export { renderDrawerHeaderNavigation_unstable as renderDrawerHeaderNavigation } from '@fluentui/react-drawer';
